export class UserGroupRequest {
    groupId: number;
    groupName: string;
    groupStatus: string;
    permList: number[];
    deletedPerms: number[];
}